export default {
  account: () => import("F:/web/layouts/account.vue").then(m => m.default || m),
  activity: () => import("F:/web/layouts/activity.vue").then(m => m.default || m),
  buy: () => import("F:/web/layouts/buy.vue").then(m => m.default || m),
  course: () => import("F:/web/layouts/course.vue").then(m => m.default || m),
  default: () => import("F:/web/layouts/default.vue").then(m => m.default || m)
}